import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/RetargetingAudience/helpers'
import retargetingAudienceRepository from '@/repository/generatedRepository/retargetingAudienceRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyFilters, prepareSortValues } from '@/helpers/filters'

const state = {
  list: [],
  filters: { ...defaultFilters(), ...StorageService.get(storageKeys.RETARGETING_AUDIENCE_FILTERS) },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state => state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, payload) {
    // eslint-disable-next-line no-unused-vars
    const { signal, pagination, clientOptions, ...restFilters } = payload
    context.commit('setFilters', payload)
    StorageService.set(storageKeys.RETARGETING_AUDIENCE_FILTERS, payload)

    const preparedFilters = prepareSortValues(omitEmptyFilters(restFilters))

    const { data } = await retargetingAudienceRepository.list({
      ...preparedFilters,
      pagination,
      signal,
    })

    context.commit('setList', { data, filters: payload })

    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await retargetingAudienceRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return retargetingAudienceRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return retargetingAudienceRepository.put(id, data)
  },
  async loadRuns(context, { id, params }) {
    const { data } = await retargetingAudienceRepository.getRuns(id, params)
    return data
  },
  pauseItem(context, id) {
    return retargetingAudienceRepository.pause(id)
  },
  resumeItem(context, id) {
    return retargetingAudienceRepository.resume(id)
  },
  refreshItem(context, id) {
    return retargetingAudienceRepository.refresh(id)
  },
  async checkSegmentAvailable(context, params) {
    const { data } = await retargetingAudienceRepository.segmentAvailable(params)
    return data
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.RETARGETING_AUDIENCE_FILTERS)
  },
  resetSearchFilter({ commit }) {
    commit('clearSearch')
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.RETARGETING_AUDIENCE_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
  clearSearch(state) {
    state.tableOptions.search = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
